module.exports = "/assets/site/images/MVM_fitness.jpg?4050aaf6d0fd0d91bb8173193518dfb8";